import type { TOC } from '@ember/component/template-only';
import type Patient from 'parog-web/models/patient';
import type { Signature as BaseCancerFormSignature } from '../base-cancer-form';
import BaseCancerForm from '../base-cancer-form';

interface Signature {
  Args: {
    form: BaseCancerFormSignature['Args']['form'];
    patient: Patient;
  };
}

const MedicalHistoryFormOncoGenericDiagnosticFieldsComponent: TOC<Signature> =
  <template><BaseCancerForm @form={{@form}} @patient={{@patient}} /></template>;

export default MedicalHistoryFormOncoGenericDiagnosticFieldsComponent;
